import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
  Button,
  Box,
  Typography,
  Grid,
  useMediaQuery,
  InputLabel,
  TextField,
  IconButton,
  InputAdornment,
  makeStyles,
  useTheme,
} from "@material-ui/core";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LoadingFloating from "../components/LoadingFloating";
import { useAlert } from "../components/Alert";

const iconArr = [
  {
    iconImg: require("../images/line.png").default,
    href: "https://line.me/zh-hant/",
  },
  {
    iconImg: require("../images/facebook.png").default,
    href: "https://www.facebook.com",
  },
  {
    iconImg: require("../images/wechat.png").default,
    href: "https://www.wechat.com/zh_HK/",
  },
];
const MUTATION_LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      id
      token
    }
  }
`;

export default function LoginPage() {
  return (
    <div>
      <LoginContent />
    </div>
  );
}

function LoginContent() {
  const useStyles = makeStyles((theme) => ({
    contentBox: {
      position: "relative",
      minHeight: "100vh",
    },
    contentImg: {
      position: "absolute",
      height: "100%",
      width: "100%",
      zIndex: "-1",
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.contentBox}>
      <Grid height="100%">
        <img
          src={"/assets/images/Login/loginImg.png"}
          className={classes.contentImg}
        />
        <Grid>
          <Grid container justify="center">
            <Grid item xs={11} sm={9} md={7} lg={5}>
              <LoginForm />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

function LoginForm() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const Alert = useAlert();

  const useStyles = makeStyles((theme) => ({
    SocialIconImg: {
      width: isPad ? "40px" : "50px",
      height: isPad ? "40px" : "50px",
      objectFit: "contain",
      verticalAlign: "middle",
      transition: "all 0.1s",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    buttonBox: {
      display: "flex",
      marginBottom: " 20px",
      marginRight: "auto",
      marginLeft: "auto",
    },
    loginButton: {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
      width: isPhone ? "120px" : isPad ? "150px" : isTable ? "200px" : "250px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "1rem" : isPad ? "1.25rem" : "1.5rem",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    registerButton: {
      backgroundColor: theme.palette.primary.main,
      color: "white",
      width: isPhone ? "120px" : isPad ? "150px" : isTable ? "200px" : "250px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "1rem" : isPad ? "1.25rem" : "1.5rem",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    input: {
      backgroundColor: "white",
      borderRadius: "4px",
      marginBottom: "20px",
    },
    title: {
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      margin: "80px 0px",
    },
  }));
  const classes = useStyles();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });
  const [login, { loading }] = useMutation(MUTATION_LOGIN, {
    onCompleted({ login }) {
      if (login) {
        localStorage.setItem("@fullhouse-webMemberId", login.id);
        localStorage.setItem("@fullhouse-webToken", login.token);
        return Alert.notice("登入成功", () => history.replace("/"));
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  function _login(data) {
    login({ variables: { ...data } });
  }

  function _error(error) {
    console.log(error);
  }
  return (
    <Box>
      <LoadingFloating loading={loading} />
      <Box padding={1} height="100%">
        <Grid container spacing={1} style={{ minHeight: "calc( 100vh - 64)" }}>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.title}>
              會員登入
            </Typography>
          </Grid>
          <Grid container item>
            <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
              帳號
            </InputLabel>
            <Controller
              name="username"
              control={control}
              rules={{
                required: "請填寫帳號",
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  placeholder="帳號即為手機號碼"
                  className={classes.input}
                  {...field}
                  error={error}
                  helperText={error && error.message}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid container item>
            <InputLabel style={{ color: "white", fontSize: "1.5rem" }} shrink>
              密碼
            </InputLabel>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "請填寫密碼",
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  className={classes.input}
                  type={showPassword ? "text" : "password"}
                  {...field}
                  fullWidth
                  error={error}
                  onKeyUp={(e) => {
                    if (e.which === 13) {
                      handleSubmit(_login, _error)();
                    }
                  }}
                  helperText={error && error.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          size="small"
                          onClick={() => setShowPassword((e) => !e)}
                        >
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid
            container
            item
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "auto",
            }}
          >
            <Button
              style={{
                color: theme.palette.secondary.light,
              }}
              onClick={() => history.push("/forget-password")}
            >
              忘記密碼?
            </Button>
          </Grid>
          <Grid className={classes.buttonBox}>
            {iconArr.map((item) => {
              return (
                <Grid>
                  <Button href={item.href}>
                    <img src={item.iconImg} className={classes.SocialIconImg} />
                  </Button>
                </Grid>
              );
            })}
          </Grid>
          <Grid container item style={{ justifyContent: "space-around" }}>
            <Grid item>
              <Button
                className={classes.registerButton}
                onClick={() => history.push("./regist-page")}
              >
                註冊
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.loginButton}
                onClick={handleSubmit(_login, _error)}
              >
                登入
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
